__turbopack_context__.v({
  "container": "dnNlRq_container",
  "customBtnContainer": "dnNlRq_customBtnContainer",
  "customClose": "dnNlRq_customClose",
  "overlayBtn": "dnNlRq_overlayBtn",
  "videoModal": "dnNlRq_videoModal",
});
